import {Inject, Injectable} from '@angular/core';
import {DataRequirements, DataRequirementsInjectionToken} from '../data.requirements';
import { LanguageMapper } from '../mappers/language.mapper';

@Injectable({
    providedIn: 'root'
})
export class GetAllLanguagesUseCase {
    constructor(
        @Inject(DataRequirementsInjectionToken) private data: DataRequirements,
        private mapper : LanguageMapper
    ) {}

    run() {
        console.log('run')
        return this.data.getAllLanguages().pipe(this.mapper.map);;
    }
}
